import React, { Component } from "react";
import { Container } from "react-bootstrap";
import Moment from "moment";
import SimplifiLeadService from "../../services/SimplifiLeadService";
import Alerts from "../common/Alerts";
import CalendarSidebar from "../common/CalendarSidebar";
import AllPropertyReservationSidebar from "../common/AllPropertyReservationSidebar";
import {
  formatMarketingConversionPrice,
  getMarketingConversionEventLabel,
} from "./marketingConversionEventLabels";

class SimplifiLeadView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      property_slug: this.props.match.params.propertySlug
        ? this.props.match.params.propertySlug
        : this.props.match.params.outsidePropertySlug,
      slug: this.props.match.params.slug,
      data: {},
      showAlertModal: false,
      alertModalType: "",
      alertModalTitle: "",
      alertModalMessage: "",
    };
  }

  componentDidMount() {
    this.getData();
  }

  getData = async () => {
    const queryString =
      "property_slug=" +
      (this.state.property_slug ? this.state.property_slug : "");
    const res = await SimplifiLeadService.getLead(this.state.slug, queryString);
    if (global.successStatus.includes(res.status)) {
      this.setState({ data: res.data ? res.data : {} });
    } else {
      this.setState({
        showAlertModal: true,
        alertModalType: "error",
        alertModalTitle: "Error",
        alertModalMessage: res.message
          ? res.message
          : "Unable to load lead detail",
      });
    }
  };

  getJson = (value) => {
    if (!value) {
      return "{}";
    }
    if (typeof value === "string") {
      return value;
    }
    try {
      return JSON.stringify(value, null, 2);
    } catch (e) {
      return "{}";
    }
  };

  renderValue = (value) => (
    <p
      className="media-body mb-0"
      style={{
        overflowWrap: "anywhere",
        wordBreak: "break-word",
        whiteSpace: "normal",
      }}
    >
      {value ? value : "-"}
    </p>
  );

  render() {
    const data = this.state.data ? this.state.data : {};
    return (
      <main>
        <Container className="innter-container">
          <div className="d-flex flex-column">
            <div className="row row-xs mg-t-0 pd-t-0 pd-lg-l-15 pd-xs-l-0">
              {this.props.match.params.propertySlug !== undefined ? (
                <div className="col-md-2 left">
                  <div className="child-menu-section">
                    <CalendarSidebar property_slug={this.state.property_slug} />
                  </div>
                </div>
              ) : (
                <div className="col-md-2 left">
                  <div className="child-menu-section">
                    <AllPropertyReservationSidebar
                      property_slug={this.state.property_slug}
                    />
                  </div>
                </div>
              )}

              <div
                className={
                  this.props.match.params.propertySlug !== undefined
                    ? "col-md-10 right"
                    : "col-md-12"
                }
              >
                <div className="col-md-12 mg-t-20 mg-b-10"></div>
                <div className="col-md-12 mg-t-0 mg-b-10 pd-t-0 pd-b-10 pd-l-15 pd-r-0">
                  <div className="dashbaord-pageHeadertitle d-flex justify-content-between align-items-center flex-wrap mg-b-0">
                    <h3>Marketing Conversion</h3>
                    <div className="d-flex flex-wrap justify-content-end bothBtn align-items-center">
                      <button
                        className="btn-success-outline-small"
                        onClick={() => {
                          if (
                            this.props.match.params.propertySlug !== undefined
                          )
                            this.props.history.push(
                              "/properties/view/" +
                                this.state.property_slug +
                                "/simplifi-leads",
                            );
                          else this.props.history.push("/simplifi-leads");
                        }}
                      >
                        Back
                      </button>
                    </div>
                  </div>
                </div>
                <div className="scrolling-carousel pd-l-15">
                  <div className="dashboardRightcard background-none pt-0 pl-30 pr-30">
                    <div className="col-md-12 pd-lg-l-30 pd-lg-r-30 pd-xs-l-15 pd-xs-r-0 mg-t-0">
                      <Alerts
                        show={this.state.showAlertModal}
                        type={this.state.alertModalType}
                        title={this.state.alertModalTitle}
                        message={this.state.alertModalMessage}
                      />
                    </div>

                    <div className="m-0">
                      <div className="row align-items-basline pd-b-0 border-bottom-0 pd-lg-l-0 pd-xs-l-15 pd-r-15 mg-t-30">
                        <div className="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-4 mg-t-5 mg-md-t-0 mg-b-15 pd-xs-l-0 pd-lg-l-30 pd-xs-r-0 pd-lg-r-30">
                          <p className="az-profile-name-text pl-0">
                            Event Type
                          </p>
                          {this.renderValue(
                            getMarketingConversionEventLabel(data.event_type),
                          )}
                        </div>
                        <div className="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-4 mg-t-5 mg-md-t-0 mg-b-15 pd-xs-l-0 pd-lg-l-30 pd-xs-r-0 pd-lg-r-30">
                          <p className="az-profile-name-text pl-0">Provider</p>
                          {this.renderValue(data.provider)}
                        </div>
                        <div className="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-4 mg-t-5 mg-md-t-0 mg-b-15 pd-xs-l-0 pd-lg-l-30 pd-xs-r-0 pd-lg-r-30">
                          <p className="az-profile-name-text pl-0">Click ID</p>
                          {this.renderValue(data.click_id)}
                        </div>
                        <div className="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-4 mg-t-5 mg-md-t-0 mg-b-15 pd-xs-l-0 pd-lg-l-30 pd-xs-r-0 pd-lg-r-30">
                          <p className="az-profile-name-text pl-0">Event ID</p>
                          {this.renderValue(data.event_id)}
                        </div>
                        <div className="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-4 mg-t-5 mg-md-t-0 mg-b-15 pd-xs-l-0 pd-lg-l-30 pd-xs-r-0 pd-lg-r-30">
                          <p className="az-profile-name-text pl-0">
                            Confirmation Code
                          </p>
                          {this.renderValue(data.confirmation_code)}
                        </div>
                        <div className="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-4 mg-t-5 mg-md-t-0 mg-b-15 pd-xs-l-0 pd-lg-l-30 pd-xs-r-0 pd-lg-r-30">
                          <p className="az-profile-name-text pl-0">Property</p>
                          {this.renderValue(data.property_name)}
                        </div>
                        <div className="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-4 mg-t-5 mg-md-t-0 mg-b-15 pd-xs-l-0 pd-lg-l-30 pd-xs-r-0 pd-lg-r-30">
                          <p className="az-profile-name-text pl-0">Price</p>
                          {this.renderValue(
                            formatMarketingConversionPrice(data.total_amount),
                          )}
                        </div>
                        {/* <div className="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-4 mg-t-5 mg-md-t-0 mg-b-15 pd-xs-l-0 pd-lg-l-30 pd-xs-r-0 pd-lg-r-30">
                          <p className="az-profile-name-text pl-0">Sent At</p>
                          <p className="media-body">
                            {data.sent_at
                              ? Moment(data.sent_at).format(
                                  global.dateTimeFormat,
                                )
                              : "-"}
                          </p>
                        </div> */}
                        {/* <div className="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-4 mg-t-5 mg-md-t-0 mg-b-15 pd-xs-l-0 pd-lg-l-30 pd-xs-r-0 pd-lg-r-30">
                          <p className="az-profile-name-text pl-0">
                            Response Code
                          </p>
                          <p className="media-body">
                            {data.response_code ? data.response_code : "-"}
                          </p>
                        </div>
                        <div className="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-4 mg-t-5 mg-md-t-0 mg-b-15 pd-xs-l-0 pd-lg-l-30 pd-xs-r-0 pd-lg-r-30">
                          <p className="az-profile-name-text pl-0">Attempts</p>
                          <p className="media-body">
                            {data.attempt_count ? data.attempt_count : 0}
                          </p>
                        </div> */}
                        <div className="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-4 mg-t-5 mg-md-t-0 mg-b-15 pd-xs-l-0 pd-lg-l-30 pd-xs-r-0 pd-lg-r-30">
                          <p className="az-profile-name-text pl-0">Created</p>
                          {this.renderValue(
                            data.created_at
                              ? Moment(data.created_at).format(
                                  global.dateTimeFormat,
                                )
                              : "-",
                          )}
                        </div>
                      </div>
                      {/* <div className="row col-md-12 mg-t-10 mg-md-t-0 pd-xs-l-0 pd-lg-l-15">
                        <div className="col-md-12 pd-lg-l-15 pd-lg-r-15 pd-xs-l-0 mg-b-20">
                          <p className="az-profile-name-text pl-0">
                            Request Payload
                          </p>
                          <pre className="bg-light p-3 rounded border media-body">
                            {this.getJson(data.request_payload)}
                          </pre>
                        </div>
                        <div className="col-md-12 pd-lg-l-15 pd-lg-r-15 pd-xs-l-0 mg-b-20">
                          <p className="az-profile-name-text pl-0">
                            Response Body
                          </p>
                          <pre className="bg-light p-3 rounded border media-body">
                            {this.getJson(data.response_body)}
                          </pre>
                        </div>
                        <div className="col-md-12 pd-lg-l-15 pd-lg-r-15 pd-xs-l-0 mg-b-20">
                          <p className="az-profile-name-text pl-0">
                            Error Message
                          </p>
                          <pre className="bg-light p-3 rounded border media-body">
                            {data.error_message ? data.error_message : "-"}
                          </pre>
                        </div>
                      </div> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Container>
      </main>
    );
  }
}

export default SimplifiLeadView;

